<div class="navbar-wrapper"
  [ngClass]="{'container': this.gradientConfig.layout === 'horizontal' && this.gradientConfig.subLayout === 'horizontal-2'}">
  <img id="logo" src="../../../../../assets/images/logo_monk/logo-monk-mcu-1.png">
  <h6 id="title-text-c" style="color: var(--mj-color-1); margin-bottom: 2%;font-size: 14px;">
    <!-- มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย -->
  </h6>
  <app-nav-content (onNavMobCollapse)="navMobCollapse()"></app-nav-content>
</div>